/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { EMPTY } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { ShowError } from '../../core/state/notification/notification.actions';
import { RestService } from '../../modules/shared/services/rest.service';
import { StorageService } from '../../modules/shared/services/storage.service';
import { StorageDirectUrl, StorageFile } from '../../types/FileDownload';
import { MatButton } from '@angular/material/button';
import { NgClass } from '@angular/common';
import { ClassDirective } from '@ngbracket/ngx-layout';

@Component({
    selector: 'dash-gis-document-link',
    templateUrl: './document-link.component.html',
    styleUrls: ['./document-link.component.scss'],
    imports: [MatButton, NgClass, ClassDirective],
})
export class DocumentLinkComponent implements OnInit {
    @Input() path: string;
    @Input() label: string;
    @Input() asLink = true;

    constructor(private store: Store, private storageService: StorageService, private rest: RestService) {}

    ngOnInit(): void {}

    getFile() {
        this.rest
            .apiGet<StorageFile | StorageDirectUrl>('document', { path: this.path })
            .pipe(
                take(1),
                switchMap((storageObject) => {
                    if (storageObject['content'] !== undefined) {
                        return this.storageService.handleBlob(storageObject as StorageFile);
                    } else if (storageObject['url'] !== undefined) {
                        return this.storageService.handleUrl(storageObject as StorageDirectUrl);
                    } else {
                        this.store.dispatch(new ShowError('Invalid response when retrieving file.'));
                        return EMPTY;
                    }
                })
            )
            .subscribe();
    }
}
